<template>
  <div class="BecomeApartner">
    <div class="BecomeApartner_mian">
      <div class="BecomeApartner_title">成为合作伙伴</div>
      <div class="annotation"><span style="color:#1373CF">注：</span>在填写资料之前,请与九州泰岳相关商务经理(010-62101086)就贵公司的定位、业务合作模式进行沟通。</div>
      <div class="stepBox">
        <el-steps :active="active" align-center finish-status="success">
          <el-step title="步骤1" description="填写信息及上传资料"></el-step>
          <el-step title="步骤2" description="等待九州泰岳审核"></el-step>
          <el-step title="步骤3" description="完成"></el-step>
        </el-steps>
      </div>
      <div class="formBox">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" :disabled="disabled">
          <el-form-item label="法定名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请填写您的公司名称"></el-input>
          </el-form-item>
          <el-form-item label="注册资金(万元RMB)" prop="TaxNumber">
            <el-input v-model="ruleForm.TaxNumber" placeholder="请填写您的注册资金"></el-input>
          </el-form-item>
          <el-form-item label="税务登记号" prop="capital">
            <el-input v-model="ruleForm.capital" placeholder="请填写您公司的税务登记号"></el-input>
          </el-form-item>
          <el-form-item label="纳税人类别" prop="category">
            <el-select v-model="ruleForm.category" placeholder="请选择纳税人类别" style="width:100%;">
              <el-option label="一般纳税人" value="1"></el-option>
              <el-option label="小额纳税人" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在省份" prop="province">
            <el-select v-model="ruleForm.province" placeholder="请选择您公司的所在省份" style="width:100%;">
              <el-option v-for="(item,index) in provinces" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在城市" prop="city">
            <el-input v-model="ruleForm.city" placeholder="请填写您公司的所在的城市"></el-input>
          </el-form-item>
          <el-form-item label="总机" prop="Switchboard">
            <el-input v-model="ruleForm.Switchboard" placeholder="请填写您公司的总机电话"></el-input>
          </el-form-item>
          <el-form-item label="传真" prop="FaxNumber">
            <el-input v-model="ruleForm.FaxNumber" placeholder="请填写您公司的传真号码"></el-input>
          </el-form-item>
          <el-form-item label="邮编" prop="ZipCode">
            <el-input v-model="ruleForm.ZipCode" placeholder="请填写您公司所在地址的邮政编码"></el-input>
          </el-form-item>
          <el-form-item label="邮寄地址" prop="MailingAddress">
            <el-input v-model="ruleForm.MailingAddress" placeholder="请填写您公司的税具体邮寄地址"></el-input>
          </el-form-item>
          <el-form-item label="网址" prop="website">
            <el-input v-model="ruleForm.website" placeholder="可以填写您公司的官网地址，以便沟通交流"></el-input>
          </el-form-item>
          <el-form-item label="业务介绍" prop="business">
            <el-input type="textarea" v-model="ruleForm.business" show-word-limit placeholder="可以填写您公司的业务内容，以便更好的展开交流与合作"></el-input>
          </el-form-item>
          <el-form-item label="企业照片" prop="image">
            <el-upload class="upload-demo" action="http://www.yhsj.net/interface/baseController/uploadFile" :on-preview="handlePreview" :on-remove="handleRemove" :on-success="handlesuccess" list-type="picture">
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" style="width:100%;height:60px;">提交</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
import VDistpicker from 'v-distpicker'
export default {
  components: { VDistpicker },
  data(){
    return{
      active: 0,
      ruleForm: {
        name: '',
        capital:'',
        TaxNumber:'',
        category:'',
        province:'',
        city:'',
        Switchboard:'',
        FaxNumber:'',
        ZipCode:'',
        MailingAddress:'',
        website:'',
        business:'',
        image:''
      },
      disabled:false,
      provinces:[{label:"北京",value:1},{label:"天津",value:2},{label:"河北",value:3},{label:"山西",value:4},{label:"内蒙古",value:5},{label:"辽宁",value:6},{label:"吉林",value:7},{label:"黑龙江",value:8}
        ,{label:"江苏",value:9},{label:"上海",value:10},{label:"山东",value:11},{label:"浙江",value:12},{label:"安徽",value:13},{label:"湖南",value:14},{label:"湖北",value:15},{label:"江西",value:16},
        {label:"河南",value:17},{label:"福建",value:18},{label:"广西",value:19},{label:"海南",value:20},{label:"云南",value:21},{label:"贵州",value:22},{label:"四川",value:23},{label:"西藏",value:24},{label:"重庆",value:25},
        {label:"陕西",value:26},{label:"青海",value:27},{label:"宁夏",value:28},{label:"甘肃",value:29},{label:"新疆",value:30},{label:"广东",value:31}
      ],
       rules: {
        name: [
          { required: true, message: '请输入法定名称', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        capital: [
          { required: true, message: '请输入注册资金(万元RMB)', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        TaxNumber: [
          { required: true, message: '请输入税务登记号', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择纳税人类别', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请输入所在省份', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请输入所在城市', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        Switchboard: [
          { required: true, message: '请输入总机', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        FaxNumber: [
          { required: true, message: '请输入传真', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        ZipCode: [
          { required: true, message: '请输入邮编', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        MailingAddress: [
          { required: true, message: '请输入邮寄地址', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        website: [
          { required: true, message: '请输入公司网址', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        business: [
          { required: true, message: '请输入业务介绍', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请上传企业照片', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ]
      },
      State:{}
    }
  },
  mounted(){
    this.queryState();
    if(!localStorage.getItem("userInfo")){
      this.$message.error('您未登录，请登录！');
    }
  },
  methods:{
    queryState(){
      if(localStorage.getItem("loginInfo")){
        this.userId = JSON.parse(localStorage.getItem("loginInfo")).userId
        let url = "/userController/front/userSearchPartnerInfo"
        this.$axios.get(url,{
          params:{
            userId:this.userId
          }
        }).then(res=>{
          console.log(res)
          this.State = res.data.data
        })
      }else{
        this.isLogin = true
      }
    },
    authentication(userId){
      let url= "/userController/front/submitPartner"
      this.$axios.post(url,{
        userId:userId,
        fdName:this.ruleForm.name,
        taxpayerType:this.ruleForm.category,
        zcMoney:this.ruleForm.capital,
        swNumber:this.ruleForm.TaxNumber,
        province:this.ruleForm.province,
        city:this.ruleForm.city,
        generalNumber:this.ruleForm.Switchboard,
        faxNo:this.ruleForm.FaxNumber,
        postalCode:this.ruleForm.ZipCode,
        addressInfo:this.ruleForm.MailingAddress,
        webUrl:this.ruleForm.website,
        describes:this.ruleForm.business,
        img:this.ruleForm.image
      }).then(res=>{
        console.log(res)
        if(res.data.code==20000){
          if (this.active++ == 0){
            this.disabled = true
          }
          this.$message({
            type: 'success',
            message: res.data.message
          });
        }else{
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    handlesuccess(response, file, fileList){
      console.log(response.data,file, fileList);
      this.ruleForm.image = response.data
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.ruleForm.image = ""
    },
    handlePreview(file) {
      console.log(file);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.ruleForm)
          if(JSON.parse(localStorage.getItem("userInfo"))){
            let userId = JSON.parse(localStorage.getItem("userInfo")).userId
            this.authentication(userId)
          }else{
            this.$message({
              type: 'error',
              message: '请先登录'
            });
            return false;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.BecomeApartner{
  margin-bottom: 100px;
  .BecomeApartner_mian{
    width: 1200px;
    margin: 18px auto;
    .BecomeApartner_title{
      font-size: 30px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #333333;
      padding: 30px 0;
      text-align: center;
      border-bottom: 1px solid #E6E8ED;
      width: 100%;
    }
    .annotation{
      font-size: 14px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #333;
      padding-top: 30px;
      text-align: center;
    }
    .stepBox{
      padding: 36px 0;
    }
    .formBox{
      width: 800px;
      margin: 0 auto;
    }
  }
}
</style>